import {NgModule} from '@angular/core';
import {CUSTOMERS} from '@infrastructure/http/customer/customers';
import {HttpCustomersService} from '@infrastructure/http/customer/http-customers.service';
import {customerDataRouting} from '@presentation/pages/texfab/customer/customer.routing';
import {SharedModule} from '@shared/shared.module';
import {AgGridModule} from 'ag-grid-angular';
import {AddCustomerComponent} from './add/add-customer.component';
import {CustomerOverviewPageComponent} from './overview/customer-overview-page.component';
import {CustomerOverviewService} from './overview/customer-overview.service';

@NgModule({
  imports: [SharedModule, AgGridModule, customerDataRouting],
  providers: [{provide: CUSTOMERS, useClass: HttpCustomersService}, CustomerOverviewService],
  declarations: [CustomerOverviewPageComponent, AddCustomerComponent]
})
export class CustomerModule {}
